<template>
  <div class="input-group-append ec-ds-search-button-container d-flex d-md-none">
    <button class="btn btn-sm btn-primary d-flex justify-content-center align-items-center ds-input ec-ds-search-btn w-100"
            type="button" @click="changeQuery()">
      <!-- <span>{{ $t(textKey) }}</span> -->
      <i class="material-icons align-bottom ml-1">search</i>
    </button>
  </div>
</template>

<script>
export default {
  name: "MobileSearchButton",
  props: {
    changeQuery: Function,
    textKey: String
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 767.5px) {
  .ec-ds-search-button-container {
    margin-left: 0;
  }
  .filters-group.ds .ec-ds-search-btn{
    border-radius: 4px !important;
  }
}
</style>
